<template>
    <app-layout>
        <base-header :shadow="false" border border-bg-from="from-amber-500" border-bg-to="to-red-500">
            <div class="flex items-center justify-between w-full">
                <h4 class="text-xl font-medium">
                    {{ $t('general.reviews') }}
                </h4>
            </div>
        </base-header>

        <table-base class="text-sm" :busy="isLoading">
            <template #head>
                <table-head>{{ $t('general.type') }}</table-head>
                <table-head>{{ $t('general.subject') }}</table-head>
                <table-head>{{ $t('general.status') }}</table-head>
                <table-head>{{ $t('date.created_at') }}</table-head>
                <table-head>{{ $t('general.reviewer') }}</table-head>
                <table-head>{{ $t('review.reviewed_at') }}</table-head>
                <table-head></table-head>
            </template>
            <template #body>
                <table-row v-for="review in reviews.data" :key="review.id">
                    <table-cell>
                        <element-badge uppercase>{{ $t('general.' + review.type) }}</element-badge>
                    </table-cell>
                    <table-cell>
                        <default-button
                            v-if="review.type === 'budget'"
                            :href="route('stores.budgets.edit', [review.reviewable.store.id, review.reviewable.id])"
                            color="green"
                            size="xs"
                            icon="external-link"
                            should-target-blank
                        >
                            {{ review.reviewable.name }} - {{ review.reviewable.year }}
                        </default-button>

                        <default-button
                            v-else-if="review.type === 'budget_projection'"
                            :href="route('stores.budget-projections.edit', [review.reviewable.store.id, review.reviewable.id])"
                            color="green"
                            size="xs"
                            icon="external-link"
                            should-target-blank
                        >
                            #{{ review.reviewable.store.number }} - {{ review.reviewable.year }}
                        </default-button>
                    </table-cell>
                    <table-cell>
                        <status-badge :review="review"/>
                    </table-cell>
                    <table-cell>
                        {{ $moment.utc(review.created_at).local().format('D. MMMM Y H:mm:ss') }}
                    </table-cell>
                    <table-cell>
                        {{ review.reviewer ? review.reviewer.name : null }}
                    </table-cell>
                    <table-cell>
                        <template v-if="review.reviewed_at">
                            {{ $moment.utc('2022-01-07T05:18:38.000Z').local().format('D. MMMM Y H:mm:ss') }}
                        </template>
                    </table-cell>
                    <table-cell>
                        <action-bar>
                            <default-button icon="clipboard-list" size="xs" :label="$t('general.review')"
                                            :href="route('reviews.show', review.id)"
                            />
                            <!--                            <delete-button :loading="isDeleting.includes(review.id)"-->
                            <!--                                           :modal-title="$t('review.delete')"-->
                            <!--                                           @delete="deleteStore(review.id)"-->
                            <!--                            >-->
                            <!--                                <template #modal-body>-->
                            <!--                                    {{ $t('review.delete_confirm') }}-->
                            <!--                                </template>-->
                            <!--                            </delete-button>-->
                        </action-bar>
                    </table-cell>
                </table-row>
            </template>
        </table-base>
        <table-pagination v-if="reviews && reviews.meta" :meta="reviews.meta.pagination" :links="reviews.links"
                          @paginate="loadPage"
        />
    </app-layout>
</template>

<script>
import Review from '@/Models/Review';
import StatusBadge from '@/Pages/Reviews/Components/StatusBadge';

export default {
    components: {StatusBadge},
    metaInfo() {
        return {
            title: this.$t('general.reviews'),
        };
    },

    data() {
        return {
            reviews: {},
            isLoading: true,
            isDeleting: [],
        };
    },

    async created() {
        await this.loadPage(1);
    },

    methods: {
        async loadPage(page) {
            this.page = page;
            await this.applyQuery();
        },

        async applyQuery() {
            this.isLoading = true;
            this.reviews = await Review.with(['reviewable.store']).pageNumber(this.page).orderBy(this.sortQuery).all();
            this.isLoading = false;
        },
    },
};
</script>
